import { CdsCheckboxField, CdsContentPanel, CdsForm, CdsInputField } from 'clayco-component-library/lib';
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import * as yup from 'yup';
import Spinner from '../../skills-experience/shared/spinner';
import PhoneControl from '../contacts/phoneControl';

const ContactInfo = ({ data, apiProvider }) => {
    const [isDirty, setIsDirty] = useState(false);
    const [model, setModel] = useState(data);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [warning, setWarning] = useState(false);
    const [payslipsChecked, setPayslipsChecked] = useState(model?.record?.sendPayslipNotifications ?? true);
    const schema = yup.object().shape({});

    async function loadContactInfo() {
        console.log(model)
        setLoading(true);
        try {
            const result = await apiProvider.Get("Profile/GetPersonalInfo");
            if (!result.error) {
                setModel(result.contactInfo);
                setPayslipsChecked(result.contactInfo?.record?.sendPayslipNotifications ?? true);
                setError(null); // Clear any previous errors
            } else {
                setError("Failed to load contact information. Please try again later.");
            }
        } catch (err) {
            setError("An error occurred while fetching contact information.");
        }
        setLoading(false);
    }

    useEffect(() => {
        loadContactInfo();
    }, []);

    const onFieldChange = (value, field) => {
        switch (field) {
            case 'payslips':
                let checked = payslipsChecked;
                checked = !checked;

                if (checked !== model?.record?.sendPayslipNotifications) {
                    setIsDirty(true);
                }
                setPayslipsChecked(checked);
                break;
            default:
                setIsDirty(true);
                break;
        }
    };

    const onSave = async (frmData) => {
        const form = schema.cast(frmData);

        // Create a single string to compare phone numbers
        form.phoneNumber = form?.phoneNumber.replace("-", "");
        const recordPhoneNum = model?.record?.personalCellPhone?.countryCode +
            model?.record?.personalCellPhone?.areaCode +
            model?.record?.personalCellPhone?.number.replace("-", "");
        const formPhoneNum = form?.areaCode + form?.phoneNumber;

        // Format phone number depending on whether or not it is US based
        if (form.international) {
            form.countryCode = form.areaCode;
            delete form.areaCode;
        } else {
            delete form.areaCode;
            form.phoneNumber = formPhoneNum;
            form.countryCode = "1";
        }
        delete form.international;

        // Determine if email or phone number changed
        const emailChanged = model.record.personalEmail !== form.personalEmail;
        const phoneChanged = recordPhoneNum !== formPhoneNum;

        // Remove unchanged fields
        form.personalEmail = emailChanged ? form.personalEmail : null;
        form.phoneNumber = phoneChanged ? form.phoneNumber : null;
        form.sendPayslipNotifications =
            model.record.sendPayslipNotifications === form.sendPayslipNotifications
                ? null
                : form.sendPayslipNotifications;

        if (form.phoneNumber === null) form.countryCode = null;

        console.log(`form: ${JSON.stringify(form)}`);
        await apiProvider.Patch("Profile/UpdateContactInfo", form);

        await loadContactInfo();

        // Only show warning if email or phone number changed
        setWarning(emailChanged || phoneChanged);

        setIsDirty(false);
    };

    const handleError = (error) => {
        console.error(error);
    };

    return (
        <>
            <div className='personalInfo-contacts'>
                <CdsForm schema={schema} onSubmit={(frmData) => onSave(frmData)} onError={handleError}>
                    <CdsContentPanel
                        title='Contact Information'
                        primaryButtonText='Save'
                        primaryButtonSubmits={true}
                        disablePrimaryButton={!isDirty}
                    >
                        {loading ? (
                            <Spinner show={loading} />
                        ) : error ? (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '150px',
                                textAlign: 'center',
                                color: '#B00020',
                                backgroundColor: '#FFF4F4',
                                borderRadius: '4px',
                                padding: '1rem',
                                fontWeight: '500'
                            }}>
                                {error}
                            </div>
                        ) : (
                            <>
                                {warning ? (
                                    <div style={{
                                        backgroundColor: 'rgb(234, 170, 0)',
                                        color: 'black',
                                        padding: '10px',
                                        border: '1px solid rgb(234, 170, 0)',
                                        borderRadius: '4px',
                                        marginBottom: '10px',
                                    }}>
                                        Please check your new email/phone for a validation link. Once you have verified your new contact information,{" "}
                                        <button
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                color: 'red',
                                                textDecoration: 'underline',
                                                cursor: 'pointer'
                                            }}
                                            onClick={async () => {
                                                await loadContactInfo();
                                                setWarning(false);
                                            }}

                                        >
                                            click here
                                        </button>{" "}
                                        to refresh your contact information.
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                                <Row>
                                    <Col md={6}>
                                        <CdsInputField style={{ position: 'relative', zIndex: -1 }}
                                            label='Personal Email Address'
                                            name='personalEmail'
                                            required={true}
                                            initialValue={model?.record?.personalEmail}
                                            onChange={(value) => onFieldChange(value, 'personalEmail')}
                                        />
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col md={6}>
                                        <CdsCheckboxField
                                            label='Send payslip notifications to my personal email address'
                                            name='sendPayslipNotifications'
                                            checked={payslipsChecked}
                                            onChange={(value) => onFieldChange(value, 'payslips')}
                                        />
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col md={8}>
                                        <text>Personal Cell Phone Number</text>
                                        <PhoneControl areaCodeInitial={model?.record?.personalCellPhone?.areaCode} numberInitial={model?.record?.personalCellPhone?.number} onChange={(value) => onFieldChange(value, 'phoneNumber')} />
                                    </Col>
                                </Row>
                            </>
                        )}
                    </CdsContentPanel>
                </CdsForm>
            </div>
        </>
    );
};

export default ContactInfo;